import styled from 'styled-components'
import { Column } from '@shipt/design-system-layouts'
import { spacing } from '@/features/shared/theme/tokens'
import { type Size, screenSizes } from '@shipt/design-system-themes'

const resolveSpacing = (value?: Parameters<typeof spacing>[0] | 'none') => {
  if (value === undefined) return null
  if (value === 'none') return 0
  return spacing(value)
}

export const GapManager = styled(Column)<{
  verticalSpacing?: Size | 'none'
  mobileVerticalSpacing?: Size | 'none'
}>`
  --vertical-spacing: ${({ verticalSpacing }) => resolveSpacing(verticalSpacing ?? 120)};

  --mobile-vertical-spacing: ${({ mobileVerticalSpacing }) =>
    resolveSpacing(mobileVerticalSpacing) ?? 'var(--vertical-spacing)'};

  @media ${screenSizes.max_mobile} {
    --cms-gap: var(--mobile-vertical-spacing);
  }

  --cms-gap: var(--vertical-spacing);

  gap: var(--cms-gap);
  margin: calc(var(--cms-gap) / 2) 0;

  & > .no-margin {
    margin: calc(var(--cms-gap) / -2) 0;
  }

  & .with-background {
    margin: calc(var(--cms-gap) / -2) 0;
    padding: calc(var(--cms-gap) / 4) 0;

    @media ${screenSizes.tablet} {
      padding: calc(var(--cms-gap) / 2) 0;
    }
  }
`
